import React, { useEffect, useRef } from 'react';

type TubesRuntime = {
  dispose?: () => void;
  tubes?: {
    setColors: (colors: string[]) => void;
    setLightsColors: (colors: string[]) => void;
  };
};

type TubesFactory = (canvas: HTMLCanvasElement, options: unknown) => TubesRuntime;

/**
 * Efeito Tubes Cursor (threejs-components via CDN) — versão só canvas, para fundo
 * atrás do conteúdo existente (ex.: tela de login), sem alterar layout/hero.
 */
export default function TubesCursor() {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const appRef = useRef<TubesRuntime | null>(null);

  useEffect(() => {
    const initTimer = window.setTimeout(() => {
      void import(
        /* @vite-ignore */
        'https://cdn.jsdelivr.net/npm/threejs-components@0.0.19/build/cursors/tubes1.min.js'
      )
        .then((module: { default?: TubesFactory }) => {
          const TubesInit = module.default;
          if (!TubesInit || !canvasRef.current) return;
          const app = TubesInit(canvasRef.current, {
            tubes: {
              colors: ['#5e72e4', '#8965e0', '#f5365c'],
              lights: {
                intensity: 200,
                colors: ['#21d4fd', '#b721ff', '#f4d03f', '#11cdef'],
              },
            },
          });
          appRef.current = app;
        })
        .catch((err: unknown) => {
          console.error('Failed to load TubesCursor module:', err);
        });
    }, 100);

    return () => {
      clearTimeout(initTimer);
      if (appRef.current && typeof appRef.current.dispose === 'function') {
        appRef.current.dispose();
      }
      appRef.current = null;
    };
  }, []);

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden>
      <canvas
        ref={canvasRef}
        className="absolute inset-0 block h-full w-full opacity-40"
      />
    </div>
  );
}
